import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-tempallocation-create',
  templateUrl: './admin-tempallocation-create.component.html',
  styleUrls: ['./admin-tempallocation-create.component.css']
})
export class AdminTempallocationCreateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
